<list-view [liste]="liste" (onLoadEnd)="refreshListe()"></list-view>